import React from 'react';
import { CustomLogo } from '../CustomLogo/CustomLogo';
import { SPLogo } from '../SPLogo/SPLogo';
import { SPLogoCollapsed } from '../SPLogoCollapsed/SPLogoCollapsed';
export const NavLogo = ({ customLogo, customCollapsedLogo, isCollapsed = false, }) => {
    if (isCollapsed) {
        return (React.createElement(CustomLogo, { customLogo: customCollapsedLogo, fallBack: SPLogoCollapsed }));
    }
    return React.createElement(CustomLogo, { customLogo: customLogo, fallBack: SPLogo });
};
//# sourceMappingURL=NavLogo.js.map